import React, { useState, useEffect } from 'react';
import PositionsListOverlay from '../../../UserComponents/modals/PositionsList.js';
import ErrorOverlay from '../../../UserComponents/overlays/ErrorOverlay.js';
import { createOppPlayer } from '../../../services/player.services';
import { isValidEmail } from '../../../utils/helper';
import { useSelector } from 'react-redux';

const initialState = {
  teamId: '',
  firstName: '',
  lastName: '',
  playerName: '',
  playerNumber: '',
  isCaptain: false,
  position: '',
};

const CreateOppPlayerOverlay = ({ isVisible, onClose, teamId, handleGetPlayers }) => {
  const user = useSelector((state) => state.auth.user);

  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [displayPhone, setDisplayPhone] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const [posVisible, setPosVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const togglePosition = () => setPosVisible(!posVisible);


  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => {
      const updatedState = {
        ...prevState,
        [name]: value,
      };
  
      // update playerName with firstName and lastName
      if (name === 'firstName' || name === 'lastName') {
        updatedState.playerName = `${updatedState.firstName} ${updatedState.lastName}`.trim();
      }
      return updatedState;
    });
  };

  useEffect(() => {
    if (!isVisible) {
      setInitialStateForm(initialState);
    } else {
      handleFormChange('teamId', teamId);
    }
  }, [isVisible, teamId]);


  const handleCreate = async () => {
    try {
      if (initialStateForm.email && !isValidEmail(initialStateForm.email)) {
        throw new Error('Invalid email format!');
      }

      setLoading(true);
      await createOppPlayer(initialStateForm, user?.token);
      await handleGetPlayers();
      setInitialStateForm({ ...initialState, teamId: initialStateForm.teamId });
      onClose();
    } catch (e) {
      setError(e);
      console.log('ERROR in CreatingPlayer =>>>>>>>>>>>> ', e.response?.data.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={`modal ${isVisible ? 'show' : ''}`}>

      {error && (
        <ErrorOverlay
          onBackdropPress={() => setError(null)}
          visible={!!error}
          error={error}
        />
      )}
      <div className="modal-content">
        <div className="modal-header">
          <h2>ADD A PLAYER</h2>

        </div>
        <div className="modal-body">

          <label className="checkbox-container full">
            Captain
            <input
              type="checkbox"
              checked={initialStateForm.isCaptain}
              onChange={() => handleFormChange('isCaptain', !initialStateForm.isCaptain)}
            />
          </label>

          {/* <div className="field-group">
            <span className="modalTitle">Name: </span>
            <input
              type="text"
              // placeholder="First Name"
              value={initialStateForm.playerName}
              onChange={(e) => handleFormChange('playerName', e.target.value)}
              className="input-field"
            />
          </div> */}

          <div className="field-group">
            <span className="modalTitle">First Name: </span>
            <input
              type="text"
              value={initialStateForm.firstName}
              onChange={(e) => handleFormChange('firstName', e.target.value)}
              className="input-field"
            />
          </div>

          <div className="field-group">
            <span className="modalTitle">Last Name: </span>
            <input
              type="text"
              value={initialStateForm.lastName}
              onChange={(e) => handleFormChange('lastName', e.target.value)}
              className="input-field"
            />
          </div>

          <div className="field-group">
            <span className="modalTitle">Jersey #: </span>
            <input
              type="number"
              // placeholder="Home Jersey #"
              value={initialStateForm.playerNumber}
              onChange={(e) => handleFormChange('playerNumber', e.target.value)}
              className="input-field"
            />
          </div>

          <div className="field-group">
            <span className="modalTitle">Position: </span>
            <input
              type="text"
              value={initialStateForm.position}
              onClick={togglePosition}
              className="input-field"
              readOnly
            />
          </div>
        </div>
        <div className="modal-footer">
          <button onClick={onClose} className="btn-secondary">Cancel</button>
          <button onClick={handleCreate} className="btn-primary">
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>

      <PositionsListOverlay
        onBackdropClick={() => togglePosition()}
        setPosition={(text) =>
          setInitialStateForm((prev) => ({ ...prev, position: text }))
        }
        visible={posVisible}
      />
    </div>
  );
};

export default CreateOppPlayerOverlay;
